import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ExamTypeService } from '../../../core/services/exam-type/document-type/exam-type.service'
import {MessageTypeService} from '../../../core/services/message-type/document-type/message-type.service';

@Component({
  selector: 'message-type-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './message-type-create.component.html',
  styleUrl: './message-type-create.component.scss',
  providers: [ExamTypeService],
  standalone: true,
})
export class MessageTypeCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private documentTypeService: MessageTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.documentTypeService.createMessageType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      nome: this.form.controls['name'].value,
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
    })
  }
}
